import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { BookOpen, Car, MessageCircle, ArrowRight } from "lucide-react";

const SECTIONS = [
  {
    id: "publicar",
    title: "Cómo publicar tu auto",
    body: "Crea tu cuenta, verifica tu identidad y completa la información de tu vehículo: fotos, ubicación, precio diario y disponibilidad. Una vez aprobado por nuestro equipo, tu auto estará visible para miles de viajeros en Baja California.",
  },
  {
    id: "host-req",
    title: "Requisitos para anfitriones",
    body: "Identificación oficial (INE o pasaporte), comprobante de domicilio, factura o carta-factura del vehículo, póliza de seguro vigente y verificación de propiedad. El vehículo debe pasar una revisión visual de RivoNes antes de su primer viaje.",
  },
  {
    id: "driver-req",
    title: "Requisitos para conductores",
    body: "Identificación oficial vigente, licencia de conducir válida, tarjeta de crédito o débito a tu nombre con fondos para la retención de seguridad y verificación facial con Stripe Identity. Edad mínima 21 años (25 para vehículos de lujo).",
  },
  {
    id: "reservas",
    title: "Cómo funcionan las reservas",
    body: "El huésped selecciona fechas y plan de protección. Una vez confirmado el pago, el anfitrión aprueba la reserva. Al inicio del viaje, ambas partes revisan el estado del vehículo. Al final, se procesa la liberación del depósito.",
  },
  {
    id: "pagos",
    title: "Pagos y comisiones",
    body: "RivoNes cobra una comisión del 15% sobre el ingreso bruto del viaje. El anfitrión recibe el 85% restante en su cuenta bancaria (Stripe Connect) dentro de 1-3 días hábiles tras finalizar el viaje sin incidentes.",
  },
  {
    id: "proteccion",
    title: "Protección, depósitos y responsabilidades",
    body: "Cada viaje incluye uno de tres planes (Básica, Estándar, Premium). Los depósitos de seguridad son retenciones temporales que se liberan tras la devolución sin daños. La protección de RivoNes no sustituye al seguro obligatorio del vehículo.",
  },
  {
    id: "seguridad",
    title: "Seguridad y verificación",
    body: "Verificamos la identidad de cada usuario con Stripe Identity, revisamos licencias de conducir y monitoreamos vehículos con GPS cuando está disponible. Reporta cualquier incidente inmediatamente al soporte 24/7.",
  },
  {
    id: "faq",
    title: "Preguntas frecuentes",
    body: "¿Tienes una pregunta específica? Consulta nuestra página completa de Preguntas Frecuentes con más de 30 preguntas categorizadas.",
  },
  {
    id: "soporte",
    title: "Contacto de soporte",
    body: "Estamos disponibles por WhatsApp y correo electrónico para resolver cualquier duda. Tiempo promedio de respuesta: menos de 30 minutos en horario laboral.",
  },
];

export default function CentroRecursosPage() {
  return (
    <div className="min-h-screen bg-sand pb-16" data-testid="centro-recursos-page">
      <div className="container-main py-10 max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-blue-500/10 text-blue-600 flex items-center justify-center">
            <BookOpen className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-3xl font-heading font-bold text-agave">Centro de Recursos</h1>
            <p className="text-sm text-neutral-600">Todo lo que necesitas saber para usar RivoNes como anfitrión o conductor.</p>
          </div>
        </div>

        <Accordion type="single" collapsible className="bg-white rounded-2xl border border-neutral-200 px-2" data-testid="centro-accordion">
          {SECTIONS.map((s) => (
            <AccordionItem key={s.id} value={s.id} data-testid={`centro-${s.id}`}>
              <AccordionTrigger className="text-left font-heading font-semibold text-agave">
                {s.title}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-neutral-700 leading-relaxed">
                {s.body}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/host/dashboard" className="btn-primary inline-flex items-center gap-2" data-testid="centro-cta-publicar">
            <Car className="w-4 h-4" />
            Publicar mi Auto
            <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/contacto" className="btn-secondary inline-flex items-center gap-2" data-testid="centro-cta-contacto">
            <MessageCircle className="w-4 h-4" />
            Contactar Soporte
          </Link>
        </div>
      </div>
    </div>
  );
}
